module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/3b1f3c4fdc0e6cb5388655abe5f5de91.png";